import { StepEntity } from '../entities/step-entity';

export default class State {
  loaded = false;

  items: Array<StepEntity> = [];
}
